import AutoLabelViewState from 'owa-mail-protection-types/lib/schema/clp/AutoLabelViewState';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';

export default function addRecommendedLabelInfoBar(
    infobarViewState: InfoBarHostViewState,
    autoLabelViewState: AutoLabelViewState
) {
    const { automatic, recommended } = autoLabelViewState;

    // If both automatic and recommended label exist and the id are the same
    // Then skip adding recommended label infobar.
    if (automatic && recommended && automatic.id == recommended.id) {
        removeInfoBarMessage(infobarViewState, 'CLPAutoLabelRecommended');
        return;
    }

    if (recommended) {
        addInfoBarMessage(infobarViewState, 'CLPAutoLabelRecommended');
    } else {
        removeInfoBarMessage(infobarViewState, 'CLPAutoLabelRecommended');
    }
}
